import { OrgTypeWithRole } from 'src/@types/org';
import { Role } from 'src/@types/role';
import { InviteStatus } from 'src/@types/userOrg';
import AcceptedOrgRow from './AcceptedOrgRow';
import PendingOrgInviteRow from './PendingOrgInviteRow';
import RejectedOrgInviteRow from './RejectedOrgInviteRow';

type OrgSwitcherRowProps = {
  org: OrgTypeWithRole;
  tab: InviteStatus;
  onSelectOrg: (org: OrgTypeWithRole, role: Role | undefined) => void;
  onInviteStatusUpdated: () => void;
  onClose?: () => void;
};

export default function OrgSwitcherRow({
  org,
  tab,
  onSelectOrg,
  onInviteStatusUpdated,
  onClose,
}: OrgSwitcherRowProps) {
  switch (tab) {
    case InviteStatus.Accepted:
      return <AcceptedOrgRow org={org} onSelectOrg={onSelectOrg} />;
    case InviteStatus.Pending:
      return <PendingOrgInviteRow org={org} onClose={onClose} onSelectOrg={onSelectOrg} />;
    case InviteStatus.Rejected:
      return <RejectedOrgInviteRow org={org} onInviteStatusUpdated={onInviteStatusUpdated} />;
    default:
      return null;
  }
}
